"use strict";

exports.__esModule = true;
exports.describeReportingPeriod = describeReportingPeriod;
exports.formatPeriodRange = formatPeriodRange;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// What a chart card says its chart covers. The reporting period's name is
// what the URL carries: "shift", "workday", or an explicit "start/end" pair
// of ISO timestamps. The first two take the labels the period selector uses;
// the pair is written out as a date range in the plant's timezone, since
// nobody should read "2026-11-03T13:00:00.000Z/2026-11-04T13:00:00.000Z"
// off a card.
var DAY = "D MMM";
var DAY_YEAR = "D MMM YYYY";
var TIME = "HH:mm";
var EN_DASH = "–";
var parse = function parse(text, timezoneName) {
  var value = (0, _momentTimezone["default"])(text, _momentTimezone["default"].ISO_8601, true);
  return value.isValid() && timezoneName ? value.tz(timezoneName) : value;
};

/**
 * An explicit "start/end" period as a date range, or null when the name is
 * not one: "3 Nov, 07:00 – 4 Nov, 07:00", "3 Nov 2026, 13:00–15:30" for one
 * day, and the year on both ends when they differ.
 */
function formatPeriodRange(name, timezoneName) {
  if (typeof name !== "string" || !name.includes("/")) {
    return null;
  }
  var _name$split = name.split("/"),
    startText = _name$split[0],
    endText = _name$split[1];
  var start = parse(startText, timezoneName);
  var end = parse(endText, timezoneName);
  if (!start.isValid() || !end.isValid()) {
    return null;
  }
  if (start.isSame(end, "day")) {
    return start.format(DAY_YEAR) + ", " + start.format(TIME) + EN_DASH + end.format(TIME);
  }
  var day = start.isSame(end, "year") ? DAY : DAY_YEAR;
  return start.format(day) + ", " + start.format(TIME) + " " + EN_DASH + " " + end.format(day) + ", " + end.format(TIME);
}

/**
 * The reporting period as a card subtitle: the selector's label for a shift
 * or workday, a date range for an explicit period, null for anything else.
 */
function describeReportingPeriod(reportingPeriod, timezoneName) {
  var name = reportingPeriod && reportingPeriod.name;
  if (name === "shift") {
    return /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "ReportingPeriodSelector.shift",
      defaultMessage: "Shift"
    });
  }
  if (name === "workday") {
    return /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "ReportingPeriodSelector.workday",
      defaultMessage: "Workday"
    });
  }
  return formatPeriodRange(name, timezoneName);
}